// Révision d'une file de cartes (R-CAR-06) : recto → « Voir la réponse » → 4 notes.
// Utilisé par l'écran Réviser et par la phase « Rappel » d'une session.
import { useState } from 'react';
import type { NoteRevision } from '@partage/types';
import { useMagasin, magasin } from '../donnees/magasin';
import type { CarteCompilee } from '@partage/contenu';

export function carteAffichable(id: string, bundles: Record<number, { cartes: Record<string, CarteCompilee> }>, cartesEtat: Record<string, { recto?: string; verso?: string }>): { recto: string; verso: string } | undefined {
  for (const b of Object.values(bundles)) {
    const c = b.cartes[id];
    if (c) return { recto: c.recto, verso: c.verso };
  }
  const manuelle = cartesEtat[id];
  if (manuelle?.recto && manuelle.verso) return { recto: manuelle.recto, verso: manuelle.verso };
  return undefined;
}

export function RevisionCartes({ file, auTerme, titre }: { file: string[]; auTerme?: () => void; titre?: string }) {
  const { bundles, etat } = useMagasin();
  const [index, setIndex] = useState(0);
  const [reponseVisible, setReponseVisible] = useState(false);
  const [faites, setFaites] = useState(0);

  const id = file[index];
  const carte = id ? carteAffichable(id, bundles, etat.cartes) : undefined;

  if (!id || !carte) {
    return (
      <div className="carte carte-revision">
        <div className="recto">{faites ? `${faites} carte${faites > 1 ? 's' : ''} révisée${faites > 1 ? 's' : ''} ✓` : 'Aucune carte à réviser pour le moment.'}</div>
        {auTerme ? <div><button className="principal" onClick={auTerme}>Continuer</button></div> : null}
      </div>
    );
  }

  async function noter(note: NoteRevision) {
    await magasin.emettre('carte_revisee', { carte: id!, note });
    setFaites((n) => n + 1);
    setReponseVisible(false);
    setIndex((i) => i + 1);
  }

  return (
    <div className="carte carte-revision">
      <div className="petit-texte doux">{titre ?? 'Révision'} · {index + 1} / {file.length}</div>
      <div className="recto">{carte.recto}</div>
      {reponseVisible ? (
        <>
          <div className="verso">{carte.verso}</div>
          <div className="notes">
            <button onClick={() => void noter(1)}>Oublié</button>
            <button onClick={() => void noter(3)}>Difficile</button>
            <button className="principal" onClick={() => void noter(4)}>Bien</button>
            <button onClick={() => void noter(5)}>Facile</button>
          </div>
        </>
      ) : (
        <div><button className="principal" onClick={() => setReponseVisible(true)}>Voir la réponse</button></div>
      )}
      {auTerme ? <div><button className="discret petit" onClick={auTerme}>Terminer la révision</button></div> : null}
    </div>
  );
}
